import { render } from "./RecipeList.vue?vue&type=template&id=373ec2c8"
import script from "./RecipeList.vue?vue&type=script&lang=js"
export * from "./RecipeList.vue?vue&type=script&lang=js"

import "./RecipeList.vue?vue&type=style&index=0&id=373ec2c8&lang=css"

import exportComponent from "/var/www/staging.no-menu.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__